import styled from "styled-components";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

/**
 * New look: the admin tables' filter row, a toolbar inside the panel above
 * the table. The pickers are regular 32px fields (8px radius, hairline), the
 * "Filter by" lead-in and the "Hide bots" checkbox read as labels.
 */
const FilterPills = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
  > div,
  > div > div {
    gap: 8px;
  }
  p,
  span.ant-typography {
    ${newLookType.label};
    color: ${(p) => getNewLookTokens(p.theme).secondary};
  }
  .ant-select {
    margin-left: 0 !important;
  }
  .ant-select .ant-select-content,
  .ant-select .ant-select-selection-item {
    color: ${(p) => getNewLookTokens(p.theme).ink};
    font-size: 13px;
  }
  .ant-checkbox-wrapper {
    display: inline-flex;
    align-items: center;
    height: 32px;
    margin-left: 4px !important;
    padding: 0 4px;
    cursor: pointer;
    p,
    span.ant-typography {
      color: ${(p) => getNewLookTokens(p.theme).text};
    }
  }
`;

export default FilterPills;
